import { ErrorHandlerService } from '../../services/error-handler.service';

/**
 * A utility function that wraps a block of code (typically an assignment) in a try-catch.
 * It ensures that if an error occurs during one assignment, the rest of the assignments
 * can continue executing without interruption. Errors are passed to a shared error handler
 * along with a custom label for easier debugging and traceability.
 *
 * This pattern is useful in content mapping or dynamic data parsing where some fields
 * might be undefined, malformed, or optional.
 */

export function safeAssign(
  action: () => void, // IMPORTANT: THIS MUST BE A PURE FUNCTION AND RETURN VOID. IF IT RETURNS GENERIC VALUES THE FUNCTION WON'T WORK AS EXPECTED.
  label: string,
  errorHandler: ErrorHandlerService
): void {
  try {
    action();
  } catch (err) {
    errorHandler.handleError(err as Error, label);
  }
}

// Test error handling
/* ((this.caasData!['formData'] as any).st_items.st_podcast! as unknown as any).value! as any */
